import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Hint, GiftIcon, showDialog } from '@src/components';
function GiftAction({ userId }: { userId: number }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);
  async function send() {
    setBusy(true);
    setError(false);
    try {
      const res = await fetch('/api/admin/santa-gifts/send-users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userIds: [userId] }),
      });
      if (!res.ok) throw Error();
      const data = await res.json();
      if (!data.gifts.length) throw Error();
      setDone(true);
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <p>{t('giftCredits.targetHint')}</p>
      {error && <Hint tone="error">{t('giftCredits.targetError')}</Hint>}
      {done ? (
        <p role="status">{t('giftCredits.targetDone')}</p>
      ) : (
        <Button disabled={busy} loading={busy} onClick={() => void send()}>
          {t('giftCredits.invite')}
        </Button>
      )}
    </>
  );
}
export function HelpDeskGift({ userId }: { userId: number }) {
  const { t } = useTranslation();
  return (
    <Button
      variant="ghost"
      className="help-desk__action-button"
      icon={<GiftIcon />}
      aria-label={t('giftCredits.invite')}
      title={t('giftCredits.invite')}
      onClick={() =>
        showDialog({ title: t('giftCredits.target'), children: <GiftAction userId={userId} /> })
      }
    />
  );
}
